
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rv-rental/[location]/[slug]/reviews",
      function () {
        return require("private-next-pages/rv-rental/[location]/[slug]/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rv-rental/[location]/[slug]/reviews"])
      });
    }
  